import React from "react";
import { Nav } from "react-bootstrap";

interface HeaderIconButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode;
  badge?: number;
}

const HeaderIconButton: React.FC<HeaderIconButtonProps> = ({
  title,
  onClick,
  children,
  badge,
}) => {
  return (
    <Nav.Item
      title={title}
      onClick={onClick}
      role="button"
      style={{
        padding: "0 8px",
        fontSize: 20,
        height: 49,
      }}
      className="d-flex justify-content-center align-items-center"
    >
      {badge !== undefined && badge > 0 && (
        <span className="position-relative">
          <span
            className="position-absolute translate-middle badge rounded-pill bg-danger"
            style={{ fontSize: 10, top: -12, left: 20 }}
          >
            {badge}
          </span>
        </span>
      )}
      {children}
    </Nav.Item>
  );
};

export default HeaderIconButton;
